var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5651 11.7329C19.5621 12.2562 19.451 12.773 19.2391 13.2494C19.0169 13.7646 18.6544 14.2036 18.1948 14.5139C17.7351 14.8242 17.1978 14.9927 16.647 14.9993L2.9201 14.9999C2.3693 14.9933 1.83199 14.8249 1.37232 14.5146C0.912661 14.2044 0.550079 13.7654 0.327884 13.2502C0.0539187 12.6574 -0.0516197 11.9978 0.0232943 11.3467C0.0982082 10.6956 0.350562 10.079 0.751597 9.56735L7.61469 1.06817C7.87425 0.734875 8.20399 0.46571 8.57939 0.2807C8.95478 0.0956899 9.36616 -0.000401929 9.78291 -0.000419854C10.1997 -0.000437779 10.6111 0.0956186 10.9865 0.280596C11.3619 0.465574 11.6916 0.73471 11.9512 1.06798L18.8151 9.56657C19.3011 10.1792 19.566 10.9442 19.5651 11.7329Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpMenu);
export default __webpack_public_path__ + "static/media/upMenu.261498856759c05279ce201bf6244cbc.svg";
export { ForwardRef as ReactComponent };